import { DebouncedFunc } from 'lodash-es';
import create from 'zustand';

import { debounce } from '@utils/browser';

export interface FilterState {
  search: string;
  debouncedSearch: string;
  setSearchValue(newValue: string): void;
  clear(): void;
  setDebouncedSearch: DebouncedFunc<(value: string) => void>;
}

export const createFilterStateHook = () =>
  create<FilterState>((set, get) => ({
    search: '',
    debouncedSearch: '',
    setDebouncedSearch: debounce((value: string) => {
      set({ debouncedSearch: value });
    }, 500),
    setSearchValue: (newValue) => {
      set({ search: newValue });
      get().setDebouncedSearch(newValue);
    },
    clear: () => {
      set({ search: '', debouncedSearch: '' });
    },
  }));
